module.exports = "/dist/03e19243272affe738654a157625ec26.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-100italic.woff
// module id = 110
// module chunks = 0